(function () {
  'use strict';

  angular
    .module('app.product-gallery', [])

    /* @ngInject */
    .directive('productGallery', ["$rootScope", "$compile", "CdnService", function ($rootScope, $compile, CdnService) {
      var directive = {
        restrict: 'A',
        link: link
      };
      return directive;

      function link(scope, element, attrs) {

        var $main = element.find('.main-picture'),
          $img = $main.find('.main-img'),
          $sub = element.find('.sub-pictures'),
          $video = element.find('.main-video');

        /* suppression du loader lorsque l'image est chargée */
        $img.on('load', function () {
          scope.$apply(function () {
            scope.productCtrl.galleryImgLoader = false;
          });
        });

        scope.$on('initZoom', function (event) {
          scope.productCtrl.galleryImgLoader = true;
          CdnService.get(attrs.zoomId, attrs.zoomSize)
            .then(function (res) {
              $main.children('.inner').zoom({
                url: res,
                touch: false,
                duration: 400,
                callback: function () {
                  scope.$apply(function () {
                    scope.productCtrl.galleryImgLoader = false;
                  });
                }
              });
            })
            .catch(function (err) {
              console.error(err);
            });
        });

        /* détruit le plugin Zoom */
        scope.$on('$destroy', function (event) {
          $main.children('.inner').trigger('zoom.destroy');
        });

        /* clic sur les images secondaires */
        $sub.on('click', '.visual', function (event) {
          event.preventDefault();
          var $this = $(this);

          /* class active sur image sélectionnée */
          $sub.find('.visual').removeClass('active');
          $this.addClass('active');

          if ($this.hasClass('video')) {
            $main.addClass('hidden');
            $video.removeClass('hidden');
            var html = '<video-player class="video-player" url="https://www.youtube.com/watch?v=' + $this.data('id') + '" autoplay="true"></video-player>';
            var el = $compile(html)(scope);
            $video.children('.inner').html(el);
            return;
          }

          $main.removeClass('hidden');
          $video.addClass('hidden').html('<div class="inner"></div>');

          /* définition de l'index pour galerie plein écran */
          $main.data('index', $this.parent().index());

          /* ajoute le loader */
          scope.$apply(function () {
            scope.productCtrl.galleryImgLoader = true;
          });

          /* change les src de l'image principale et du Zoom */
          $img.attr('src', $this.data('size-url'));
          $main.find('.zoomImg').attr('src', $this.data('zoom-url'));
        });

        /* clic sur l'image principale - ouvre la galerie plein écran */
        $main.data('index', 0).click(function (event) {
          if (typeof $.fn.lightGallery === 'undefined') {
            $rootScope.$broadcast('showPageLoader', true);
            /* chargement ajax du plugin Lightgallery */
            $.ajax({
              url: '/js/plugins/jquery.lightgallery.min.js',
              dataType: 'script',
              cache: true,
              success: function () {
                $rootScope.$broadcast('showPageLoader', false);
                initLightGallery();
              }
            });
          } else {
            initLightGallery();
          }
        });

        /* initialisation du plugin Lightgallery */
        function initLightGallery() {
          var dynamicEl = [];
          $sub.find('a').not('.video').each(function () {
            var $this = $(this);
            dynamicEl.push({ thumb: $this.data('zoom-thumb-url'), src: $this.data('zoom-url') });
          });
          $sub
            .on('onCloseAfter.lg', function (event) {
              $(event.target).removeData('lightGallery');
            })
            .lightGallery({
              nextHtml: '<i class="glyphicon glyphicon-chevron-right"></i>',
              prevHtml: '<i class="glyphicon glyphicon-chevron-left"></i>',
              fullscreenHtml: '<i class="fullscreen-icon glyphicon glyphicon-fullscreen"></i><i class="fullscreen-exit glyphicon glyphicon-fullscreen-exit"></i>',
              closeHtml: '<i class="glyphicon glyphicon-remove"></i>',
              dynamic: true,
              dynamicEl: dynamicEl,
              index: $main.data('index'),
              mode: 'lg-slide',
              thumbnail: navigator.userAgent.toLowerCase().match(/(iphone|ipod)/) ? false : true
            });
        }
      }
    }]);
})();
